import { TextInputBase } from '@synqo/frontend-component-library';

const noop = () => false;

export function SecretField(props: { label: string; value?: string }) {
    const isHidden = !props.value;

    return (
        <TextInputBase
            label={props.label}
            name="secret"
            value={props.value ?? ''}
            onChange={noop}
            placeholder={isHidden ? '*******' : undefined}
            locked
            readOnly
            valid
        />
    );
}
